// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annoymouseUser {
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 26px !important;
  text-align: left;
  color: white !important;
}

.annoymouseEmail {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 22px !important;
  letter-spacing: -0.01em !important;
  text-align: left;
  color: white !important;
}

.suggestionCardTitleStyles {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  margin-bottom: 16px;
}

@media (max-width: 1024px) {
  .suggestionCardTitleStyles {
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    margin-bottom: 16px;
  }
}
.dashboardLiveClassesText {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #1d2026;
}

@media (max-width: 1024px) {
  .dashboardLiveClassesText {
    font-size: 10px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.01em;
    text-align: left;
    color: #1d2026;
  }
  .dashboardRecentActivitedTitle {
    font-size: 10px !important;
  }
  .dashboardThisWeek {
    font-size: 10px !important;
  }
  .tabStyles {
    font-size: 10px !important;
    padding: 5px !important;
  }
  .tab-parent-div {
    padding: 0 15px 0 15px !important;
  }
}
.dashboardRecentActivitedTitle {
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #1d2026;
}

.dashboardThisWeek {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: right;
  color: #6e7485;
}

.dashboardUpcomingDate {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 12px;
  color: #1d2026;
}

.progress-live-classes .progress-bar {
  background-color: #4403bf;
}

@media (max-width: 1024px) {
  .dashboard-progress-navbar-1024 {
    background-color: #33140b;
    min-height: 85px !important;
    padding: 10px 4px 8px 4px !important;
    margin-bottom: 12px !important;
    border-radius: 6px !important;
    margin: 15px 14px !important;
  }
  .dashboard-progress-navbar-1024 .progress-label {
    font-size: 10px !important;
    margin-bottom: 1px !important;
  }
  .dashboard-progress-navbar-1024 .progress {
    height: 7px !important;
    border-radius: 4px !important;
  }
  .dashboard-progress-navbar-1024 .progress-percentage {
    font-size: 9px !important;
    margin-left: 4px !important;
  }
  .dashboard-progress-navbar-1024 .profile-pic {
    width: 38px !important;
    height: 38px !important;
    margin-right: 6px;
  }
  .dashboard-progress-navbar-1024 .annoymouseUser {
    font-size: 12px !important;
    color: #fff;
    font-weight: 600 !important;
  }
  .dashboard-progress-navbar-1024 .annoymouseEmail {
    font-size: 10px !important;
    color: #d3c8ff;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/StudentDashboard/styles.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;EACF;AACF;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAEA;EACE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,uBAAA;IACA,gBAAA;IACA,cAAA;EACF;EACA;IACE,0BAAA;EACF;EACA;IACE,0BAAA;EACF;EACA;IACE,0BAAA;IACA,uBAAA;EACF;EACA;IACE,iCAAA;EACF;AACF;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE;IACE,yBAAA;IACA,2BAAA;IACA,oCAAA;IACA,8BAAA;IACA,6BAAA;IACA,4BAAA;EAAF;EAEA;IACE,0BAAA;IACA,6BAAA;EAAF;EAEA;IACE,sBAAA;IACA,6BAAA;EAAF;EAEA;IACE,yBAAA;IACA,2BAAA;EAAF;EAEA;IACE,sBAAA;IACA,uBAAA;IACA,iBAAA;EAAF;EAEA;IACE,0BAAA;IACA,WAAA;IACA,2BAAA;EAAF;EAEA;IACE,0BAAA;IACA,cAAA;EAAF;AACF","sourcesContent":[".annoymouseUser {\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  line-height: 26px !important;\n  text-align: left;\n  color: white !important;\n}\n\n.annoymouseEmail {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 22px !important;\n  letter-spacing: -0.01em !important;\n  text-align: left;\n  color: white !important;\n}\n\n.suggestionCardTitleStyles {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: left;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 1024px) {\n  .suggestionCardTitleStyles {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n    text-align: left;\n    margin-bottom: 16px;\n  }\n}\n\n.dashboardLiveClassesText {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.01em;\n  text-align: left;\n  color: #1d2026;\n}\n@media (max-width: 1024px) {\n  .dashboardLiveClassesText {\n    font-size: 10px;\n    font-weight: 500;\n    line-height: 18px;\n    letter-spacing: -0.01em;\n    text-align: left;\n    color: #1d2026;\n  }\n  .dashboardRecentActivitedTitle {\n    font-size: 10px !important;\n  }\n  .dashboardThisWeek {\n    font-size: 10px !important;\n  }\n  .tabStyles {\n    font-size: 10px !important;\n    padding: 5px !important;\n  }\n  .tab-parent-div {\n    padding: 0 15px 0 15px !important;\n  }\n}\n\n.dashboardRecentActivitedTitle {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.01em;\n  text-align: left;\n  color: #1d2026;\n}\n\n.dashboardThisWeek {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.01em;\n  text-align: right;\n  color: #6e7485;\n}\n\n.dashboardUpcomingDate {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.01em;\n  text-align: left;\n  margin-right: 12px;\n  color: #1d2026;\n}\n\n.progress-live-classes .progress-bar {\n  background-color: #4403bf;\n}\n\n@media (max-width: 1024px) {\n  .dashboard-progress-navbar-1024 {\n    background-color: #33140b;\n    min-height: 85px !important;\n    padding: 10px 4px 8px 4px !important;\n    margin-bottom: 12px !important;\n    border-radius: 6px !important;\n    margin: 15px 14px !important;\n  }\n  .dashboard-progress-navbar-1024 .progress-label {\n    font-size: 10px !important;\n    margin-bottom: 1px !important;\n  }\n  .dashboard-progress-navbar-1024 .progress {\n    height: 7px !important;\n    border-radius: 4px !important;\n  }\n  .dashboard-progress-navbar-1024 .progress-percentage {\n    font-size: 9px !important;\n    margin-left: 4px !important;\n  }\n  .dashboard-progress-navbar-1024 .profile-pic {\n    width: 38px !important;\n    height: 38px !important;\n    margin-right: 6px;\n  }\n  .dashboard-progress-navbar-1024 .annoymouseUser {\n    font-size: 12px !important;\n    color: #fff;\n    font-weight: 600 !important;\n  }\n  .dashboard-progress-navbar-1024 .annoymouseEmail {\n    font-size: 10px !important;\n    color: #d3c8ff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
